<template>
  <header class="wg-header">
    <div class="wg-header-inner">
      <a class="wg-brand" href="/" aria-label="WhatsApp GB início">
        <span class="wg-brand-mark">GB</span>
        <span>
          <strong>WhatsApp GB</strong>
          <small>whats-gb.app</small>
        </span>
      </a>

      <button class="wg-menu-toggle" type="button" @click="isMenuOpen = !isMenuOpen" aria-label="Abrir menu">
        <span></span>
        <span></span>
        <span></span>
      </button>

      <nav class="wg-nav" :class="{ 'is-open': isMenuOpen }" aria-label="Primary">
        <a href="/" :class="{ 'is-active': page === 'home' }">Início</a>
        <a href="/download/" :class="{ 'is-active': page === 'download' }">Download</a>
        <a href="/como-instalar-gb-whatsapp/" :class="{ 'is-active': page === 'install' }">Instalar</a>
        <a href="/como-atualizar-gb-whatsapp/" :class="{ 'is-active': page === 'update' }">Atualizar</a>
        <a href="/gb-whatsapp-nao-funciona/" :class="{ 'is-active': page === 'notWorking' }">Não funciona</a>
        <a href="/gb-whatsapp-foi-bloqueado/" :class="{ 'is-active': page === 'banned' }">Bloqueado</a>
        <a href="/gb-whatsapp-e-seguro/" :class="{ 'is-active': page === 'safe' }">Segurança</a>
        <a href="/gb-whatsapp-vs-whatsapp/" :class="{ 'is-active': page === 'compare' }">Comparativo</a>
      </nav>
    </div>
  </header>
</template>

<script>
export default {
  name: 'HeadNav',
  props: {
    selectedLanguage: {
      type: String,
      default: 'pt'
    },
    page: {
      type: String,
      default: 'home'
    }
  },
  data() {
    return {
      isMenuOpen: false
    };
  }
};
</script>

<style lang="scss">
.wg-header {
  position: sticky;
  top: 0;
  z-index: 20;
  background: rgba(255, 255, 255, 0.94);
  border-bottom: 1px solid #e0ebe5;
  backdrop-filter: blur(12px);
}

.wg-header-inner {
  position: relative;
  width: min(1180px, calc(100% - 32px));
  min-height: 72px;
  margin: 0 auto;
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 18px;
}

.wg-brand {
  display: inline-flex;
  align-items: center;
  gap: 12px;
  font-family: var(--wg-font-heading, 'Oswald', 'Arial Narrow', Arial, sans-serif);
  color: #10251a;
  text-decoration: none;

  strong,
  small {
    display: block;
  }

  strong {
    font-size: 20px;
    font-weight: 400;
    line-height: 1.1;
  }

  small {
    margin-top: 3px;
    color: #647067;
    font-size: 12px;
  }
}

.wg-brand-mark {
  width: 42px;
  height: 42px;
  border-radius: 8px;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  background: #16a34a;
  color: #ffffff;
  font-family: var(--wg-font-heading, 'Oswald', 'Arial Narrow', Arial, sans-serif);
  font-weight: 500;
}

.wg-nav {
  display: flex;
  align-items: center;
  gap: 4px;
  flex-shrink: 0;

  a {
    min-height: 40px;
    padding: 0 9px;
    border-radius: 6px;
    display: inline-flex;
    align-items: center;
    color: #26352d;
    text-decoration: none;
    font-family: var(--wg-font-heading, 'Oswald', 'Arial Narrow', Arial, sans-serif);
    font-weight: 400;
    font-size: 14px;
    letter-spacing: 0;
    white-space: nowrap;
  }

  a:hover {
    background: #edf7f1;
    color: #145c39;
  }

  a.is-active {
    background: #16a34a;
    color: #ffffff;
  }
}

.wg-menu-toggle {
  display: none;
  border: 0;
  background: transparent;
  padding: 8px;

  span {
    display: block;
    width: 24px;
    height: 2px;
    margin: 5px 0;
    background: #10251a;
  }
}

@media (max-width: 760px) {
  .wg-header-inner {
    min-height: 64px;
  }

  .wg-menu-toggle {
    display: block;
  }

  .wg-nav {
    display: none;
    position: absolute;
    left: 16px;
    right: 16px;
    top: 66px;
    padding: 12px;
    background: #ffffff;
    border: 1px solid #e0ebe5;
    border-radius: 8px;
    box-shadow: 0 16px 32px rgba(15, 31, 25, 0.12);
    flex-direction: column;
    align-items: stretch;

    &.is-open {
      display: flex;
    }
  }
}
</style>
